import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";

/**
 * Image chargée via api.get (cookie/JWT transmis) — les balises <img src>
 * n'envoient pas l'Authorization header. Réutilise le principe de
 * AttachmentThumb du chat mission.
 */
export const AuthImage = ({ url, alt = "", className = "", onClick, testId, fallback = null }) => {
  const [blobUrl, setBlobUrl] = useState(null);
  const [failed, setFailed] = useState(false);
  useEffect(() => {
    let cancelled = false;
    let created = null;
    setBlobUrl(null); setFailed(false);
    if (!url) { setFailed(true); return undefined; }
    const rel = url.startsWith("/api/") ? url.slice(4) : url;
    (async () => {
      try {
        const { data } = await api.get(rel, { responseType: "blob" });
        if (cancelled) return;
        created = window.URL.createObjectURL(data);
        setBlobUrl(created);
      } catch (e) { if (!cancelled) setFailed(true); }
    })();
    return () => { cancelled = true; if (created) window.URL.revokeObjectURL(created); };
  }, [url]);

  if (failed) return fallback;
  if (!blobUrl) return <div className={`${className} bg-[#E4E7EB] animate-pulse`} data-testid={testId ? `${testId}-loading` : undefined} />;
  return (
    <img src={blobUrl} alt={alt} className={`${className} ${onClick ? "cursor-zoom-in" : ""}`}
      onClick={onClick} data-testid={testId} />
  );
};

export const Lightbox = ({ url, legende, onClose, testId = "lightbox" }) => (
  <div className="fixed inset-0 z-50 bg-black/90 flex flex-col items-center justify-center p-4" onClick={onClose} data-testid={testId}>
    <button className="absolute top-4 right-4 text-white text-2xl" onClick={onClose} aria-label="Fermer" data-testid={`${testId}-close`}>×</button>
    <AuthImage url={url} alt={legende} className="max-w-full max-h-[85vh] object-contain" />
    {legende && <p className="mt-3 text-sm text-white/90">{legende}</p>}
  </div>
);
